/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S2_P1Inputs */

const tr_hakkimizda_s2_p1 = /** @type {(inputs: Hakkimizda_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkiye'de e-ticaret için sunulan SaaS çözümlerinde altyapı eksikleri ve karşılığını bulmayan yüksek fiyatlar, Emonse®'nin çıkış noktası oldu. Biz, işletmelerin temel teknoloji ihtiyaçlarına erişmek için gereğinden fazla bedel ödemek zorunda kalmadığı, sağlam ve sürdürülebilir bir yapı kurmak amacıyla yola çıktık.`)
};

const en_hakkimizda_s2_p1 = /** @type {(inputs: Hakkimizda_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infrastructure gaps and high prices that do not deliver matching value in the SaaS solutions offered for e-commerce in Türkiye were the starting point of Emonse®. We set out to build a solid and sustainable structure in which businesses do not have to pay more than necessary to access their basic technology needs.`)
};

const de_hakkimizda_s2_p1 = /** @type {(inputs: Hakkimizda_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infrastrukturlücken und hohe Preise ohne entsprechenden Gegenwert bei den SaaS-Lösungen, die in der Türkei für den E-Commerce angeboten werden, waren der Ausgangspunkt von Emonse®. Wir sind angetreten, um eine solide und nachhaltige Struktur aufzubauen, in der Unternehmen für den Zugang zu ihren grundlegenden Technologiebedürfnissen nicht mehr als nötig bezahlen müssen.`)
};

const ru_hakkimizda_s2_p1 = /** @type {(inputs: Hakkimizda_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пробелы в инфраструктуре и высокие цены, не соответствующие получаемой ценности, в SaaS-решениях, предлагаемых для электронной коммерции в Турции, стали отправной точкой Emonse®. Мы начали работу с целью построить надёжную и устойчивую структуру, в которой компаниям не приходится платить больше необходимого за доступ к базовым технологическим потребностям.`)
};

/**
* | output |
* | --- |
* | "Infrastructure gaps and high prices that do not deliver matching value in the SaaS solutions offered for e-commerce in Türkiye were the starting point of Emo..." |
*
* @param {Hakkimizda_S2_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s2_p1 = /** @type {((inputs?: Hakkimizda_S2_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S2_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s2_p1(inputs)
	if (locale === "de") return de_hakkimizda_s2_p1(inputs)
	if (locale === "ru") return ru_hakkimizda_s2_p1(inputs)
	return tr_hakkimizda_s2_p1(inputs)
});